export default __webpack_public_path__ + "static/media/avatarA8.3cf248c9.png";